// Booking form tokens for ht-connect are minted only after the same free check level as
// the advisor, so a bot can't get a token to post requests with.
export const connectFormTokenBotIdOptions = { advancedOptions: { checkLevel: 'basic' } } as const

export const connectFormTokenBotIdRoute = {
  path: '/api/connect/form-token',
  method: 'POST',
  ...connectFormTokenBotIdOptions,
}
